export interface paths {
    '/api/v1/webhooks/cash-manager-transaction': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/cash-manager-transaction/pending': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/cash-manager-transaction/reject': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/contacts/{contactId}/role': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    contactId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ContactsContactRolePermissions'];
                        'application/json': components['schemas']['ContactsContactRolePermissions'];
                        'text/json': components['schemas']['ContactsContactRolePermissions'];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Forbidden */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    contactId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['ChangeContactRole'];
                    'application/json': components['schemas']['ChangeContactRole'];
                    'text/json': components['schemas']['ChangeContactRole'];
                    'application/*+json': components['schemas']['ChangeContactRole'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ContactsContactRolePermissions'];
                        'application/json': components['schemas']['ContactsContactRolePermissions'];
                        'text/json': components['schemas']['ContactsContactRolePermissions'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Forbidden */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/contacts/roles': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerContactsContactRolePermissions'];
                        'application/json': components['schemas']['CollectionAnswerContactsContactRolePermissions'];
                        'text/json': components['schemas']['CollectionAnswerContactsContactRolePermissions'];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Forbidden */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/contacts/{contactId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    contactId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['UpdateContact'];
                    'application/json': components['schemas']['UpdateContact'];
                    'text/json': components['schemas']['UpdateContact'];
                    'application/*+json': components['schemas']['UpdateContact'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ContactsContact'];
                        'application/json': components['schemas']['ContactsContact'];
                        'text/json': components['schemas']['ContactsContact'];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Forbidden */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    contactId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Forbidden */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/contacts': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['CreateContact'];
                    'application/json': components['schemas']['CreateContact'];
                    'text/json': components['schemas']['CreateContact'];
                    'application/*+json': components['schemas']['CreateContact'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ContactsContact'];
                        'application/json': components['schemas']['ContactsContact'];
                        'text/json': components['schemas']['ContactsContact'];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Forbidden */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                        'text/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/conversions/quotes': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['CreateConversionQuote'];
                    'application/json': components['schemas']['CreateConversionQuote'];
                    'text/json': components['schemas']['CreateConversionQuote'];
                    'application/*+json': components['schemas']['CreateConversionQuote'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ConversionsConversionQuote'];
                        'application/json': components['schemas']['ConversionsConversionQuote'];
                        'text/json': components['schemas']['ConversionsConversionQuote'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/conversions': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['CreateConversion'];
                    'application/json': components['schemas']['CreateConversion'];
                    'text/json': components['schemas']['CreateConversion'];
                    'application/*+json': components['schemas']['CreateConversion'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ConversionsConversionIdAnswer'];
                        'application/json': components['schemas']['ConversionsConversionIdAnswer'];
                        'text/json': components['schemas']['ConversionsConversionIdAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/conversions/{conversionId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    conversionId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ConversionsConversionAnswer'];
                        'application/json': components['schemas']['ConversionsConversionAnswer'];
                        'text/json': components['schemas']['ConversionsConversionAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/conversions/{conversionId}/history': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    conversionId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerConversionsConversionHistoryRecordAnswer'];
                        'application/json': components['schemas']['CollectionAnswerConversionsConversionHistoryRecordAnswer'];
                        'text/json': components['schemas']['CollectionAnswerConversionsConversionHistoryRecordAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/conversions/conversion-dates': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    /** @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul> */
                    buyCurrency: components['schemas']['CurrencyIsoCode'];
                    /** @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul> */
                    sellCurrency: components['schemas']['CurrencyIsoCode'];
                    startDate: string;
                };
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ConversionsConversionDates'];
                        'application/json': components['schemas']['ConversionsConversionDates'];
                        'text/json': components['schemas']['ConversionsConversionDates'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/conversion/cash-manager-trade': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/conversion/funds-arrived': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/conversion/trade-settled': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/conversion/trade-closed': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/conversion/deposit-arrived': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/fundings/{fundingId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    fundingId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['FundingsFundingAnswer'];
                        'application/json': components['schemas']['FundingsFundingAnswer'];
                        'text/json': components['schemas']['FundingsFundingAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/fundings/{fundingId}/history': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    fundingId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerFundingsFundingHistoryRecordAnswer'];
                        'application/json': components['schemas']['CollectionAnswerFundingsFundingHistoryRecordAnswer'];
                        'text/json': components['schemas']['CollectionAnswerFundingsFundingHistoryRecordAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/quotes': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['CreatePaymentQuote'][];
                    'application/json': components['schemas']['CreatePaymentQuote'][];
                    'text/json': components['schemas']['CreatePaymentQuote'][];
                    'application/*+json': components['schemas']['CreatePaymentQuote'][];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerPaymentsCreatePaymentQuoteAnswer'];
                        'application/json': components['schemas']['CollectionAnswerPaymentsCreatePaymentQuoteAnswer'];
                        'text/json': components['schemas']['CollectionAnswerPaymentsCreatePaymentQuoteAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['CreatePayment'][];
                    'application/json': components['schemas']['CreatePayment'][];
                    'text/json': components['schemas']['CreatePayment'][];
                    'application/*+json': components['schemas']['CreatePayment'][];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerPaymentsCreatePaymentAnswer'];
                        'application/json': components['schemas']['CollectionAnswerPaymentsCreatePaymentAnswer'];
                        'text/json': components['schemas']['CollectionAnswerPaymentsCreatePaymentAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/{paymentId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    paymentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['PaymentsPaymentWithConversionAnswer'];
                        'application/json': components['schemas']['PaymentsPaymentWithConversionAnswer'];
                        'text/json': components['schemas']['PaymentsPaymentWithConversionAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/{paymentId}/refund': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    paymentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['RefundsRefundAnswer'];
                        'application/json': components['schemas']['RefundsRefundAnswer'];
                        'text/json': components['schemas']['RefundsRefundAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/{paymentId}/history': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    paymentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerPaymentsPaymentHistoryRecordAnswer'];
                        'application/json': components['schemas']['CollectionAnswerPaymentsPaymentHistoryRecordAnswer'];
                        'text/json': components['schemas']['CollectionAnswerPaymentsPaymentHistoryRecordAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/limitations': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    /** @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul> */
                    currency?: components['schemas']['CurrencyIsoCode'];
                    /** @description <ul><li><i>Priority</i> - priority</li><li><i>Regular</i> - regular</li></ul> */
                    paymentType?: components['schemas']['PaymentType'];
                    /** @description <ul><li><i>CERTIS</i> - certis</li><li><i>CHAPS</i> - chaps</li><li><i>CHATS</i> - chats</li><li><i>CHIPS</i> - chips</li><li><i>DCL</i> - dcl</li><li><i>DirectEntry</i> - direct-entry</li><li><i>EFT</i> - eft</li><li><i>Elixir</i> - elixir</li><li><i>FAST</i> - fast</li><li><i>FedACH</i> - fed-ach</li><li><i>Fedwire</i> - fedwire</li><li><i>FPS</i> - fps</li><li><i>GiroZrt</i> - giro-zrt</li><li><i>IBG</i> - ibg</li><li><i>IMPS</i> - imps</li><li><i>NEFT</i> - neft</li><li><i>NICS</i> - nics</li><li><i>PESONet</i> - pesonet</li><li><i>SEPA</i> - sepa</li><li><i>SIC</i> - sic</li><li><i>SKN</i> - skn</li><li><i>Straksclearing</i> - straksclearing</li><li><i>SWIFT</i> - swift</li><li><i>TARGET2</i> - target2</li><li><i>TransFonD</i> - trans-fond</li></ul> */
                    payNetworkType?: components['schemas']['PayNetworkType'];
                };
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerPaymentsPaymentLimitationAnswer'];
                        'application/json': components['schemas']['CollectionAnswerPaymentsPaymentLimitationAnswer'];
                        'text/json': components['schemas']['CollectionAnswerPaymentsPaymentLimitationAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/invalid-dates': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    /** @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul> */
                    currency: components['schemas']['CurrencyIsoCode'];
                    startDate: string;
                };
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerDateOnly'];
                        'application/json': components['schemas']['CollectionAnswerDateOnly'];
                        'text/json': components['schemas']['CollectionAnswerDateOnly'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/purpose-codes': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    /** @description <ul><li><i>AD</i></li><li><i>AE</i></li><li><i>AF</i></li><li><i>AG</i></li><li><i>AI</i></li><li><i>AL</i></li><li><i>AM</i></li><li><i>AO</i></li><li><i>AQ</i></li><li><i>AR</i></li><li><i>AS</i></li><li><i>AT</i></li><li><i>AU</i></li><li><i>AW</i></li><li><i>AX</i></li><li><i>AZ</i></li><li><i>BA</i></li><li><i>BB</i></li><li><i>BD</i></li><li><i>BE</i></li><li><i>BF</i></li><li><i>BG</i></li><li><i>BH</i></li><li><i>BI</i></li><li><i>BJ</i></li><li><i>BL</i></li><li><i>BM</i></li><li><i>BN</i></li><li><i>BO</i></li><li><i>BQ</i></li><li><i>BR</i></li><li><i>BS</i></li><li><i>BT</i></li><li><i>BV</i></li><li><i>BW</i></li><li><i>BY</i></li><li><i>BZ</i></li><li><i>CA</i></li><li><i>CC</i></li><li><i>CD</i></li><li><i>CF</i></li><li><i>CG</i></li><li><i>CH</i></li><li><i>CI</i></li><li><i>CK</i></li><li><i>CL</i></li><li><i>CM</i></li><li><i>CN</i></li><li><i>CO</i></li><li><i>CR</i></li><li><i>CU</i></li><li><i>CV</i></li><li><i>CW</i></li><li><i>CX</i></li><li><i>CY</i></li><li><i>CZ</i></li><li><i>DE</i></li><li><i>DJ</i></li><li><i>DK</i></li><li><i>DM</i></li><li><i>DO</i></li><li><i>DZ</i></li><li><i>EC</i></li><li><i>EE</i></li><li><i>EG</i></li><li><i>EH</i></li><li><i>ER</i></li><li><i>ES</i></li><li><i>ET</i></li><li><i>FI</i></li><li><i>FJ</i></li><li><i>FK</i></li><li><i>FM</i></li><li><i>FO</i></li><li><i>FR</i></li><li><i>GA</i></li><li><i>GB</i></li><li><i>GD</i></li><li><i>GE</i></li><li><i>GF</i></li><li><i>GG</i></li><li><i>GH</i></li><li><i>GI</i></li><li><i>GL</i></li><li><i>GM</i></li><li><i>GN</i></li><li><i>GP</i></li><li><i>GQ</i></li><li><i>GR</i></li><li><i>GS</i></li><li><i>GT</i></li><li><i>GU</i></li><li><i>GW</i></li><li><i>GY</i></li><li><i>HK</i></li><li><i>HM</i></li><li><i>HN</i></li><li><i>HR</i></li><li><i>HT</i></li><li><i>HU</i></li><li><i>ID</i></li><li><i>IE</i></li><li><i>IL</i></li><li><i>IM</i></li><li><i>IN</i></li><li><i>IO</i></li><li><i>IQ</i></li><li><i>IR</i></li><li><i>IS</i></li><li><i>IT</i></li><li><i>JE</i></li><li><i>JM</i></li><li><i>JO</i></li><li><i>JP</i></li><li><i>KE</i></li><li><i>KG</i></li><li><i>KH</i></li><li><i>KI</i></li><li><i>KM</i></li><li><i>KN</i></li><li><i>KP</i></li><li><i>KR</i></li><li><i>KW</i></li><li><i>KY</i></li><li><i>KZ</i></li><li><i>LA</i></li><li><i>LB</i></li><li><i>LC</i></li><li><i>LI</i></li><li><i>LK</i></li><li><i>LR</i></li><li><i>LS</i></li><li><i>LT</i></li><li><i>LU</i></li><li><i>LV</i></li><li><i>LY</i></li><li><i>MA</i></li><li><i>MC</i></li><li><i>MD</i></li><li><i>ME</i></li><li><i>MF</i></li><li><i>MG</i></li><li><i>MH</i></li><li><i>MK</i></li><li><i>ML</i></li><li><i>MM</i></li><li><i>MN</i></li><li><i>MO</i></li><li><i>MP</i></li><li><i>MQ</i></li><li><i>MR</i></li><li><i>MS</i></li><li><i>MT</i></li><li><i>MU</i></li><li><i>MV</i></li><li><i>MW</i></li><li><i>MX</i></li><li><i>MY</i></li><li><i>MZ</i></li><li><i>NA</i></li><li><i>NC</i></li><li><i>NE</i></li><li><i>NF</i></li><li><i>NG</i></li><li><i>NI</i></li><li><i>NL</i></li><li><i>NO</i></li><li><i>NP</i></li><li><i>NR</i></li><li><i>NU</i></li><li><i>NZ</i></li><li><i>OM</i></li><li><i>PA</i></li><li><i>PE</i></li><li><i>PF</i></li><li><i>PG</i></li><li><i>PH</i></li><li><i>PK</i></li><li><i>PL</i></li><li><i>PM</i></li><li><i>PN</i></li><li><i>PR</i></li><li><i>PS</i></li><li><i>PT</i></li><li><i>PW</i></li><li><i>PY</i></li><li><i>QA</i></li><li><i>RE</i></li><li><i>RO</i></li><li><i>RS</i></li><li><i>RU</i></li><li><i>RW</i></li><li><i>SA</i></li><li><i>SB</i></li><li><i>SC</i></li><li><i>SD</i></li><li><i>SE</i></li><li><i>SG</i></li><li><i>SH</i></li><li><i>SI</i></li><li><i>SJ</i></li><li><i>SK</i></li><li><i>SL</i></li><li><i>SM</i></li><li><i>SN</i></li><li><i>SO</i></li><li><i>SR</i></li><li><i>SS</i></li><li><i>ST</i></li><li><i>SV</i></li><li><i>SX</i></li><li><i>SY</i></li><li><i>SZ</i></li><li><i>TC</i></li><li><i>TD</i></li><li><i>TF</i></li><li><i>TG</i></li><li><i>TH</i></li><li><i>TJ</i></li><li><i>TK</i></li><li><i>TL</i></li><li><i>TM</i></li><li><i>TN</i></li><li><i>TO</i></li><li><i>TR</i></li><li><i>TT</i></li><li><i>TV</i></li><li><i>TW</i></li><li><i>TZ</i></li><li><i>UA</i></li><li><i>UG</i></li><li><i>UM</i></li><li><i>US</i></li><li><i>UY</i></li><li><i>UZ</i></li><li><i>VA</i></li><li><i>VC</i></li><li><i>VE</i></li><li><i>VG</i></li><li><i>VI</i></li><li><i>VN</i></li><li><i>VU</i></li><li><i>WF</i></li><li><i>WS</i></li><li><i>XK</i></li><li><i>YE</i></li><li><i>YT</i></li><li><i>ZA</i></li><li><i>ZM</i></li><li><i>ZW</i></li></ul> */
                    payeeBankCountry: components['schemas']['CountryIsoCode'];
                    /** @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul> */
                    currency: components['schemas']['CurrencyIsoCode'];
                    /** @description <ul><li><i>Company</i> - company</li><li><i>Individual</i> - individual</li></ul> */
                    payeeEntityType: components['schemas']['LegalEntityType'];
                };
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerPaymentsPaymentPurposeCode'];
                        'application/json': components['schemas']['CollectionAnswerPaymentsPaymentPurposeCode'];
                        'text/json': components['schemas']['CollectionAnswerPaymentsPaymentPurposeCode'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/payment/ready-to-send': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/payment/released': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/payment/failed': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/payment/compliance-failed': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/ping': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    'api-version'?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/refunds/{refundId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    refundId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['RefundsRefundAnswer'];
                        'application/json': components['schemas']['RefundsRefundAnswer'];
                        'text/json': components['schemas']['RefundsRefundAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/conversions/{conversionId}/confirmation/pdf': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    conversionId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/fundings/{fundingId}/confirmation/pdf': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    fundingId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/refunds/{refundId}/confirmation/pdf': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    refundId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/payments/{paymentId}/confirmation/pdf': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    paymentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/reports/{reportId}/pdf': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    reportId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/reports/{reportId}/status': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    reportId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ReportsReportAnswer'];
                        'application/json': components['schemas']['ReportsReportAnswer'];
                        'text/json': components['schemas']['ReportsReportAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/reports/pdf': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['CreateReport'];
                    'application/json': components['schemas']['CreateReport'];
                    'text/json': components['schemas']['CreateReport'];
                    'application/*+json': components['schemas']['CreateReport'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['ReportsReportAnswer'];
                        'application/json': components['schemas']['ReportsReportAnswer'];
                        'text/json': components['schemas']['ReportsReportAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/transfer/transfer-created': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/transfer/transfer-completed': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/wallets': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    isVisibleOnly: boolean;
                };
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerWalletsWallet'];
                        'application/json': components['schemas']['CollectionAnswerWalletsWallet'];
                        'text/json': components['schemas']['CollectionAnswerWalletsWallet'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/wallets/{walletId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    walletId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['WalletsWallet'];
                        'application/json': components['schemas']['WalletsWallet'];
                        'text/json': components['schemas']['WalletsWallet'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/wallets/balances': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerBalancesBalance'];
                        'application/json': components['schemas']['CollectionAnswerBalancesBalance'];
                        'text/json': components['schemas']['CollectionAnswerBalancesBalance'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/wallets/{walletId}/funding-accounts': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    walletId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerFundingsFundingAccountAnswer'];
                        'application/json': components['schemas']['CollectionAnswerFundingsFundingAccountAnswer'];
                        'text/json': components['schemas']['CollectionAnswerFundingsFundingAccountAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/wallets/visibility': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': string[];
                    'application/json': string[];
                    'text/json': string[];
                    'application/*+json': string[];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/wallets/transactions': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    currencies?: components['schemas']['CurrencyIsoCode'][];
                    statuses?: components['schemas']['TransactionStatus'][];
                    reference?: string;
                    accountAmountGte?: number;
                    accountAmountLte?: number;
                    types?: components['schemas']['TransactionType'][];
                    createdAtGte?: string;
                    createdAtLte?: string;
                    completedAtGte?: string;
                    completedAtLte?: string;
                    sort?: components['schemas']['TransactionsSorting'][];
                    limit: number;
                    offset: number;
                };
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['PaginatedAnswerWalletsTransactionAnswer'];
                        'application/json': components['schemas']['PaginatedAnswerWalletsTransactionAnswer'];
                        'text/json': components['schemas']['PaginatedAnswerWalletsTransactionAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/wallets/currencies': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    isPayable?: boolean;
                    isFundable?: boolean;
                    isConvertible?: boolean;
                };
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'text/plain': components['schemas']['CollectionAnswerWalletsCurrencyRecord'];
                        'application/json': components['schemas']['CollectionAnswerWalletsCurrencyRecord'];
                        'text/json': components['schemas']['CollectionAnswerWalletsCurrencyRecord'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        BalancesBalance: {
            currency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            amount: number;
            /** Format: date-time */
            createdAt?: string | null;
        };
        BeneficiariesBankAccount: {
            country: components['schemas']['CountryIsoCode'];
            name: string;
            currency: components['schemas']['CurrencyIsoCode'];
            routing: components['schemas']['BeneficiariesRouting'];
        };
        BeneficiariesLegalEntity: {
            type: components['schemas']['LegalEntityType'];
            personFirstName?: string | null;
            personLastName?: string | null;
            companyName?: string | null;
            country: components['schemas']['CountryIsoCode'];
            addressLine?: string | null;
            city?: string | null;
            postCode?: string | null;
            stateOrProvince?: string | null;
        };
        BeneficiariesRouting: {
            sortCode?: string | null;
            accountNumber?: string | null;
            iban?: string | null;
            bicSwift?: string | null;
            aba?: string | null;
            bsb?: string | null;
            clabe?: string | null;
            cnaps?: string | null;
            ifsc?: string | null;
            institutionNumber?: string | null;
            bankCode?: string | null;
            branchCode?: string | null;
            incorporationNumber?: string | null;
        };
        ChangeContactRole: {
            newRole: components['schemas']['UserRole'];
        };
        CollectionAnswerBalancesBalance: {
            items: components['schemas']['BalancesBalance'][];
        };
        CollectionAnswerContactsContactRolePermissions: {
            items: components['schemas']['ContactsContactRolePermissions'][];
        };
        CollectionAnswerConversionsConversionHistoryRecordAnswer: {
            items: components['schemas']['ConversionsConversionHistoryRecordAnswer'][];
        };
        CollectionAnswerDateOnly: {
            items: string[];
        };
        CollectionAnswerFundingsFundingAccountAnswer: {
            items: components['schemas']['FundingsFundingAccountAnswer'][];
        };
        CollectionAnswerFundingsFundingHistoryRecordAnswer: {
            items: components['schemas']['FundingsFundingHistoryRecordAnswer'][];
        };
        CollectionAnswerPaymentsCreatePaymentAnswer: {
            items: components['schemas']['PaymentsCreatePaymentAnswer'][];
        };
        CollectionAnswerPaymentsCreatePaymentQuoteAnswer: {
            items: components['schemas']['PaymentsCreatePaymentQuoteAnswer'][];
        };
        CollectionAnswerPaymentsPaymentHistoryRecordAnswer: {
            items: components['schemas']['PaymentsPaymentHistoryRecordAnswer'][];
        };
        CollectionAnswerPaymentsPaymentLimitationAnswer: {
            items: components['schemas']['PaymentsPaymentLimitationAnswer'][];
        };
        CollectionAnswerPaymentsPaymentPurposeCode: {
            items: components['schemas']['PaymentsPaymentPurposeCode'][];
        };
        CollectionAnswerWalletsCurrencyRecord: {
            items: components['schemas']['WalletsCurrencyRecord'][];
        };
        CollectionAnswerWalletsWallet: {
            items: components['schemas']['WalletsWallet'][];
        };
        ContactsContact: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            organizationId: string;
            firstName: string;
            lastName: string;
            email: string;
            phoneNumber?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
            isDeleted: boolean;
        };
        ContactsContactRolePermissions: {
            /** Format: uuid */
            contactId: string;
            role: components['schemas']['UserRole'];
            permissions: components['schemas']['RolePermission'][];
            isDeleted: boolean;
        };
        ConversionsConversionAnswer: {
            /** Format: uuid */
            id: string;
            idempotencyId: string;
            fixedSide: components['schemas']['FixedSide'];
            buyCurrency: components['schemas']['CurrencyIsoCode'];
            sellCurrency: components['schemas']['CurrencyIsoCode'];
            /**
             * Format: string
             * @description <ul>Quotation of two currencies</ul>
             */
            currencyPair: string;
            /** Format: double */
            clientBuyAmount: number;
            /** Format: double */
            clientSellAmount: number;
            /** Format: double */
            clientRate: number;
            status: components['schemas']['ConversionsConversionStatus'];
            /** Format: date */
            conversionDate: string;
            /** Format: date-time */
            completedAt?: string | null;
            /** Format: date-time */
            settlementDate?: string | null;
            /** Format: date */
            finalConversionDate?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
        };
        ConversionsConversionDates: {
            /**
             * Format: string
             * @description <ul>Quotation of two currencies</ul>
             */
            currencyPair: string;
            /** Format: date */
            startDate: string;
            /** Format: date */
            firstConversionDate: string;
            /** Format: date */
            nextDayConversionDate: string;
            /** Format: date */
            defaultConversionDate: string;
            /** Format: date */
            optimizeLiquidityConversionDate: string;
            /** Format: date-time */
            firstConversionCutoffDatetime: string;
            invalidConversionDates: {
                [key: string]: string;
            };
        };
        ConversionsConversionHistoryRecordAnswer: {
            status: components['schemas']['ConversionsConversionStatus'];
            /** Format: date-time */
            createdAt: string;
        };
        ConversionsConversionIdAnswer: {
            /** Format: uuid */
            conversionId: string;
        };
        ConversionsConversionQuote: {
            /** Format: uuid */
            id: string;
            buyCurrency: components['schemas']['CurrencyIsoCode'];
            sellCurrency: components['schemas']['CurrencyIsoCode'];
            /**
             * Format: string
             * @description <ul>Quotation of two currencies</ul>
             */
            currencyPair: string;
            fixedSide: components['schemas']['FixedSide'];
            /** Format: double */
            amount: number;
            /** Format: double */
            clientBuyAmount: number;
            /** Format: double */
            clientSellAmount: number;
            /** Format: double */
            clientRate: number;
            /** Format: date */
            possibleConversionDate: string;
        };
        /**
         * @description <ul><li><i>Cancelled</i> - cancelled</li><li><i>Completed</i> - completed</li><li><i>Created</i> - created</li><li><i>Failed</i> - failed</li><li><i>Pending</i> - pending</li></ul>
         * @enum {string}
         */
        ConversionsConversionStatus: ConversionsConversionStatus;
        /**
         * @description <ul><li><i>AD</i></li><li><i>AE</i></li><li><i>AF</i></li><li><i>AG</i></li><li><i>AI</i></li><li><i>AL</i></li><li><i>AM</i></li><li><i>AO</i></li><li><i>AQ</i></li><li><i>AR</i></li><li><i>AS</i></li><li><i>AT</i></li><li><i>AU</i></li><li><i>AW</i></li><li><i>AX</i></li><li><i>AZ</i></li><li><i>BA</i></li><li><i>BB</i></li><li><i>BD</i></li><li><i>BE</i></li><li><i>BF</i></li><li><i>BG</i></li><li><i>BH</i></li><li><i>BI</i></li><li><i>BJ</i></li><li><i>BL</i></li><li><i>BM</i></li><li><i>BN</i></li><li><i>BO</i></li><li><i>BQ</i></li><li><i>BR</i></li><li><i>BS</i></li><li><i>BT</i></li><li><i>BV</i></li><li><i>BW</i></li><li><i>BY</i></li><li><i>BZ</i></li><li><i>CA</i></li><li><i>CC</i></li><li><i>CD</i></li><li><i>CF</i></li><li><i>CG</i></li><li><i>CH</i></li><li><i>CI</i></li><li><i>CK</i></li><li><i>CL</i></li><li><i>CM</i></li><li><i>CN</i></li><li><i>CO</i></li><li><i>CR</i></li><li><i>CU</i></li><li><i>CV</i></li><li><i>CW</i></li><li><i>CX</i></li><li><i>CY</i></li><li><i>CZ</i></li><li><i>DE</i></li><li><i>DJ</i></li><li><i>DK</i></li><li><i>DM</i></li><li><i>DO</i></li><li><i>DZ</i></li><li><i>EC</i></li><li><i>EE</i></li><li><i>EG</i></li><li><i>EH</i></li><li><i>ER</i></li><li><i>ES</i></li><li><i>ET</i></li><li><i>FI</i></li><li><i>FJ</i></li><li><i>FK</i></li><li><i>FM</i></li><li><i>FO</i></li><li><i>FR</i></li><li><i>GA</i></li><li><i>GB</i></li><li><i>GD</i></li><li><i>GE</i></li><li><i>GF</i></li><li><i>GG</i></li><li><i>GH</i></li><li><i>GI</i></li><li><i>GL</i></li><li><i>GM</i></li><li><i>GN</i></li><li><i>GP</i></li><li><i>GQ</i></li><li><i>GR</i></li><li><i>GS</i></li><li><i>GT</i></li><li><i>GU</i></li><li><i>GW</i></li><li><i>GY</i></li><li><i>HK</i></li><li><i>HM</i></li><li><i>HN</i></li><li><i>HR</i></li><li><i>HT</i></li><li><i>HU</i></li><li><i>ID</i></li><li><i>IE</i></li><li><i>IL</i></li><li><i>IM</i></li><li><i>IN</i></li><li><i>IO</i></li><li><i>IQ</i></li><li><i>IR</i></li><li><i>IS</i></li><li><i>IT</i></li><li><i>JE</i></li><li><i>JM</i></li><li><i>JO</i></li><li><i>JP</i></li><li><i>KE</i></li><li><i>KG</i></li><li><i>KH</i></li><li><i>KI</i></li><li><i>KM</i></li><li><i>KN</i></li><li><i>KP</i></li><li><i>KR</i></li><li><i>KW</i></li><li><i>KY</i></li><li><i>KZ</i></li><li><i>LA</i></li><li><i>LB</i></li><li><i>LC</i></li><li><i>LI</i></li><li><i>LK</i></li><li><i>LR</i></li><li><i>LS</i></li><li><i>LT</i></li><li><i>LU</i></li><li><i>LV</i></li><li><i>LY</i></li><li><i>MA</i></li><li><i>MC</i></li><li><i>MD</i></li><li><i>ME</i></li><li><i>MF</i></li><li><i>MG</i></li><li><i>MH</i></li><li><i>MK</i></li><li><i>ML</i></li><li><i>MM</i></li><li><i>MN</i></li><li><i>MO</i></li><li><i>MP</i></li><li><i>MQ</i></li><li><i>MR</i></li><li><i>MS</i></li><li><i>MT</i></li><li><i>MU</i></li><li><i>MV</i></li><li><i>MW</i></li><li><i>MX</i></li><li><i>MY</i></li><li><i>MZ</i></li><li><i>NA</i></li><li><i>NC</i></li><li><i>NE</i></li><li><i>NF</i></li><li><i>NG</i></li><li><i>NI</i></li><li><i>NL</i></li><li><i>NO</i></li><li><i>NP</i></li><li><i>NR</i></li><li><i>NU</i></li><li><i>NZ</i></li><li><i>OM</i></li><li><i>PA</i></li><li><i>PE</i></li><li><i>PF</i></li><li><i>PG</i></li><li><i>PH</i></li><li><i>PK</i></li><li><i>PL</i></li><li><i>PM</i></li><li><i>PN</i></li><li><i>PR</i></li><li><i>PS</i></li><li><i>PT</i></li><li><i>PW</i></li><li><i>PY</i></li><li><i>QA</i></li><li><i>RE</i></li><li><i>RO</i></li><li><i>RS</i></li><li><i>RU</i></li><li><i>RW</i></li><li><i>SA</i></li><li><i>SB</i></li><li><i>SC</i></li><li><i>SD</i></li><li><i>SE</i></li><li><i>SG</i></li><li><i>SH</i></li><li><i>SI</i></li><li><i>SJ</i></li><li><i>SK</i></li><li><i>SL</i></li><li><i>SM</i></li><li><i>SN</i></li><li><i>SO</i></li><li><i>SR</i></li><li><i>SS</i></li><li><i>ST</i></li><li><i>SV</i></li><li><i>SX</i></li><li><i>SY</i></li><li><i>SZ</i></li><li><i>TC</i></li><li><i>TD</i></li><li><i>TF</i></li><li><i>TG</i></li><li><i>TH</i></li><li><i>TJ</i></li><li><i>TK</i></li><li><i>TL</i></li><li><i>TM</i></li><li><i>TN</i></li><li><i>TO</i></li><li><i>TR</i></li><li><i>TT</i></li><li><i>TV</i></li><li><i>TW</i></li><li><i>TZ</i></li><li><i>UA</i></li><li><i>UG</i></li><li><i>UM</i></li><li><i>US</i></li><li><i>UY</i></li><li><i>UZ</i></li><li><i>VA</i></li><li><i>VC</i></li><li><i>VE</i></li><li><i>VG</i></li><li><i>VI</i></li><li><i>VN</i></li><li><i>VU</i></li><li><i>WF</i></li><li><i>WS</i></li><li><i>XK</i></li><li><i>YE</i></li><li><i>YT</i></li><li><i>ZA</i></li><li><i>ZM</i></li><li><i>ZW</i></li></ul>
         * @enum {string}
         */
        CountryIsoCode: CountryIsoCode;
        CreateContact: {
            /** Format: uuid */
            contactId: string;
            role: components['schemas']['UserRole'];
            firstName: string;
            lastName: string;
            email: string;
            phoneNumber?: string | null;
        };
        CreateConversion: {
            idempotencyId: string;
            /** Format: uuid */
            conversionQuoteId: string;
            buyCurrency: components['schemas']['CurrencyIsoCode'];
            sellCurrency: components['schemas']['CurrencyIsoCode'];
            fixedSide: components['schemas']['FixedSide'];
            /** Format: double */
            amount: number;
            isApproved: boolean;
        };
        CreateConversionQuote: {
            buyCurrency: components['schemas']['CurrencyIsoCode'];
            sellCurrency: components['schemas']['CurrencyIsoCode'];
            fixedSide: components['schemas']['FixedSide'];
            /** Format: double */
            amount: number;
        };
        CreatePayment: {
            /** Format: uuid */
            paymentQuoteId: string;
            /** Format: double */
            amount: number;
            currency: components['schemas']['CurrencyIsoCode'];
            accountCurrency: components['schemas']['CurrencyIsoCode'];
            paymentType: components['schemas']['PaymentType'];
            isApproved: boolean;
            idempotencyId: string;
            chargeType?: components['schemas']['PaymentChargeType'];
            reason: string;
            reference: string;
            userInfo?: string | null;
            purposeCode?: string | null;
            invoiceNumber?: string | null;
            /** Format: date */
            invoiceDate?: string | null;
            /** Format: date */
            paymentDate: string;
            payee: components['schemas']['PaymentsPayeeDetails'];
        };
        CreatePaymentQuote: {
            uniqueId: string;
            /** Format: double */
            amount: number;
            currency: components['schemas']['CurrencyIsoCode'];
            accountCurrency: components['schemas']['CurrencyIsoCode'];
            paymentType: components['schemas']['PaymentType'];
            /** Format: date-time */
            paymentDate: string;
            chargeType?: components['schemas']['PaymentChargeType'];
            bankCountry: components['schemas']['CountryIsoCode'];
        };
        CreateReport: {
            type: components['schemas']['ReportType'];
            /** Format: date-time */
            completedAtFrom: string;
            /** Format: date-time */
            completedAtTo: string;
            currencies?: components['schemas']['CurrencyIsoCode'][] | null;
        };
        /**
         * @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul>
         * @enum {string}
         */
        CurrencyIsoCode: CurrencyIsoCode;
        /**
         * @description <ul><li><i>Buy</i> - buy</li><li><i>Sell</i> - sell</li></ul>
         * @enum {string}
         */
        FixedSide: FixedSide;
        FundingsFundingAccountAnswer: {
            title: string;
            description: string;
            properties: components['schemas']['FundingsFundingAccountProperty'][];
        };
        FundingsFundingAccountProperty: {
            field: string;
            value: string;
        };
        FundingsFundingAnswer: {
            /** Format: uuid */
            id: string;
            /** Format: double */
            amount: number;
            currency: components['schemas']['CurrencyIsoCode'];
            sender: components['schemas']['FundingsSender'];
            /** Format: date-time */
            valueDate: string;
            status: components['schemas']['FundingsFundingStatus'];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: date-time */
            completedAt?: string | null;
        };
        FundingsFundingHistoryRecordAnswer: {
            status: components['schemas']['FundingsFundingStatus'];
            /** Format: date-time */
            createdAt: string;
        };
        /**
         * @description <ul><li><i>Completed</i> - completed</li><li><i>Deleted</i> - deleted</li><li><i>Pending</i> - pending</li></ul>
         * @enum {string}
         */
        FundingsFundingStatus: FundingsFundingStatus;
        FundingsSender: {
            /** Format: uuid */
            id?: string | null;
            country?: components['schemas']['CountryIsoCode'];
            address?: string | null;
            name?: string | null;
            bic?: string | null;
            iban?: string | null;
            accountNumber?: string | null;
            routingCode?: string | null;
        };
        /**
         * @description <ul><li><i>Company</i> - company</li><li><i>Individual</i> - individual</li></ul>
         * @enum {string}
         */
        LegalEntityType: LegalEntityType;
        MicrosoftAspNetCoreMvcProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        PaginatedAnswerWalletsTransactionAnswer: {
            items: components['schemas']['WalletsTransactionAnswer'][];
            /** Format: int32 */
            totalItems: number;
            hasMore: boolean;
        };
        /**
         * @description <ul><li><i>CERTIS</i> - certis</li><li><i>CHAPS</i> - chaps</li><li><i>CHATS</i> - chats</li><li><i>CHIPS</i> - chips</li><li><i>DCL</i> - dcl</li><li><i>DirectEntry</i> - direct-entry</li><li><i>EFT</i> - eft</li><li><i>Elixir</i> - elixir</li><li><i>FAST</i> - fast</li><li><i>FedACH</i> - fed-ach</li><li><i>Fedwire</i> - fedwire</li><li><i>FPS</i> - fps</li><li><i>GiroZrt</i> - giro-zrt</li><li><i>IBG</i> - ibg</li><li><i>IMPS</i> - imps</li><li><i>NEFT</i> - neft</li><li><i>NICS</i> - nics</li><li><i>PESONet</i> - pesonet</li><li><i>SEPA</i> - sepa</li><li><i>SIC</i> - sic</li><li><i>SKN</i> - skn</li><li><i>Straksclearing</i> - straksclearing</li><li><i>SWIFT</i> - swift</li><li><i>TARGET2</i> - target2</li><li><i>TransFonD</i> - trans-fond</li></ul>
         * @enum {string}
         */
        PayNetworkType: PayNetworkType;
        /**
         * @description <ul><li><i>Ours</i> - ours</li><li><i>Shared</i> - shared</li></ul>
         * @enum {string}
         */
        PaymentChargeType: PaymentChargeType;
        /**
         * @description <ul><li><i>InReview</i> - in_review</li><li><i>Passed</i> - passed</li><li><i>Rejected</i> - rejected</li></ul>
         * @enum {string}
         */
        PaymentReviewStatus: PaymentReviewStatus;
        /**
         * @description <ul><li><i>Priority</i> - priority</li><li><i>Regular</i> - regular</li></ul>
         * @enum {string}
         */
        PaymentType: PaymentType;
        PaymentsCreatePaymentAnswer: {
            idempotencyId: string;
            payment?: components['schemas']['PaymentsPaymentAnswer'];
            errorCode?: string | null;
        };
        PaymentsCreatePaymentQuoteAnswer: {
            uniqueId: string;
            paymentQuote?: components['schemas']['PaymentsPaymentQuoteAnswer'];
            errorCode?: string | null;
        };
        PaymentsPayeeDetails: {
            legalEntity: components['schemas']['BeneficiariesLegalEntity'];
            bankAccount: components['schemas']['BeneficiariesBankAccount'];
        };
        PaymentsPaymentAnswer: {
            /** Format: uuid */
            id: string;
            idempotencyId: string;
            /** Format: double */
            amount: number;
            currency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            accountAmount: number;
            accountCurrency: components['schemas']['CurrencyIsoCode'];
            type: components['schemas']['PaymentType'];
            chargeType?: components['schemas']['PaymentChargeType'];
            status: components['schemas']['PaymentsPaymentStatus'];
            reviewStatus?: components['schemas']['PaymentReviewStatus'];
            reason: string;
            reference: string;
            userInfo?: string | null;
            purposeCode?: string | null;
            failureReason?: string | null;
            /** Format: double */
            feeAmount: number;
            /** Format: double */
            basicFeeAmount: number;
            feeCurrency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            feeAmountInBaseCurrency: number;
            /** Format: double */
            basicFeeAmountInBaseCurrency: number;
            baseCurrency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            feeClientRate?: number | null;
            /**
             * Format: string
             * @description <ul>Quotation of two currencies</ul>
             */
            feeCurrencyPair?: string | null;
            invoiceNumber?: string | null;
            /** Format: date */
            invoiceDate?: string | null;
            /** Format: date */
            paymentDate?: string | null;
            /** Format: date */
            finalPaymentDate?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: date-time */
            completedAt?: string | null;
            payee: components['schemas']['PaymentsPayeeDetails'];
            /** Format: date */
            conversionDate?: string | null;
        };
        PaymentsPaymentHistoryRecordAnswer: {
            status: components['schemas']['PaymentsPaymentStatus'];
            /** Format: date-time */
            createdAt: string;
        };
        PaymentsPaymentLimitationAnswer: {
            currency: components['schemas']['CurrencyIsoCode'];
            paymentType: components['schemas']['PaymentType'];
            payNetworkName: string;
            /** Format: double */
            minimumAmountPerTransaction?: number | null;
            /** Format: double */
            maximumAmountPerTransaction?: number | null;
            /** Format: date-span */
            eta: string;
            limitedCountries: components['schemas']['CountryIsoCode'][];
            restrictedCountries: components['schemas']['CountryIsoCode'][];
        };
        PaymentsPaymentPurposeCode: {
            code: string;
            description: string;
        };
        PaymentsPaymentQuoteAnswer: {
            /** Format: uuid */
            id: string;
            uniqueId: string;
            /** Format: double */
            amount: number;
            currency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            accountAmount: number;
            accountCurrency: components['schemas']['CurrencyIsoCode'];
            paymentType: components['schemas']['PaymentType'];
            /** Format: double */
            clientFeeAmountInBaseCurrency: number;
            /** Format: double */
            basicFeeAmountInBaseCurrency: number;
            baseCurrency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            clientFeeAmount: number;
            /** Format: double */
            basicFeeAmount: number;
            feeCurrency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            clientPaymentRate?: number | null;
            /**
             * Format: string
             * @description <ul>Quotation of two currencies</ul>
             */
            paymentCurrencyPair?: string | null;
            /** Format: double */
            clientFeeRate?: number | null;
            /**
             * Format: string
             * @description <ul>Quotation of two currencies</ul>
             */
            feeCurrencyPair?: string | null;
            /** Format: date */
            possibleConversionDate?: string | null;
            /** Format: date */
            paymentDate: string;
            /** Format: date */
            possiblePaymentDate: string;
            chargeType?: components['schemas']['PaymentChargeType'];
        };
        /**
         * @description <ul><li><i>Cancelled</i> - cancelled</li><li><i>Completed</i> - completed</li><li><i>Created</i> - created</li><li><i>Failed</i> - failed</li><li><i>Pending</i> - pending</li><li><i>Refunded</i> - refunded</li></ul>
         * @enum {string}
         */
        PaymentsPaymentStatus: PaymentsPaymentStatus;
        PaymentsPaymentWithConversionAnswer: {
            payment: components['schemas']['PaymentsPaymentAnswer'];
            conversions: components['schemas']['ConversionsConversionAnswer'][];
        };
        RefundsRefundAnswer: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            organizationId: string;
            /** Format: uuid */
            paymentId: string;
            status: components['schemas']['RefundsRefundStatus'];
            reason: string;
            /** Format: double */
            amount: number;
            currency: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: date-time */
            completedAt: string;
        };
        /**
         * @description <ul><li><i>Completed</i> - completed</li></ul>
         * @enum {string}
         */
        RefundsRefundStatus: RefundsRefundStatus;
        /**
         * @description <ul><li><i>Completed</i> - completed</li><li><i>Failed</i> - failed</li><li><i>Pending</i> - pending</li></ul>
         * @enum {string}
         */
        ReportStatus: ReportStatus;
        /**
         * @description <ul><li><i>AccountStatement</i> - account-statement</li><li><i>BalanceActivity</i> - balance-activity</li></ul>
         * @enum {string}
         */
        ReportType: ReportType;
        ReportsReportAnswer: {
            /** Format: uuid */
            id: string;
            status: components['schemas']['ReportStatus'];
            /** Format: date */
            statementDate: string;
        };
        /**
         * @description <ul><li><i>AssignRoleWalletManager</i> - assign-role-wallet-manager</li><li><i>AssignRoleWalletViewer</i> - assign-role-wallet-viewer</li><li><i>DeleteContact</i> - delete-contact</li><li><i>MakeConversion</i> - make-conversion</li><li><i>MakePayment</i> - make-payment</li><li><i>SetWalletVisibility</i> - set-wallet-visibility</li><li><i>View</i> - view</li></ul>
         * @enum {string}
         */
        RolePermission: RolePermission;
        /**
         * @description <ul><li><i>Credit</i> - credit</li><li><i>Debit</i> - debit</li></ul>
         * @enum {string}
         */
        TransactionKind: TransactionKind;
        /**
         * @description <ul><li><i>Cancelled</i> - cancelled</li><li><i>Completed</i> - completed</li><li><i>Created</i> - created</li><li><i>Failed</i> - failed</li><li><i>Pending</i> - pending</li></ul>
         * @enum {string}
         */
        TransactionStatus: TransactionStatus;
        /**
         * @description <ul><li><i>Conversion</i> - conversion</li><li><i>Funding</i> - funding</li><li><i>Payment</i> - payment</li><li><i>PaymentFee</i> - payment-fee</li><li><i>Refund</i> - refund</li></ul>
         * @enum {string}
         */
        TransactionType: TransactionType;
        /**
         * @description <ul><li><i>AccountAmountAsc</i> - accountAmount</li><li><i>AccountAmountDesc</i> - -accountAmount</li><li><i>CompletedAtAsc</i> - completedAt</li><li><i>CompletedAtDesc</i> - -completedAt</li><li><i>CreatedAtAsc</i> - createdAt</li><li><i>CreatedAtDesc</i> - -createdAt</li><li><i>StatusAsc</i> - status</li><li><i>StatusDesc</i> - -status</li><li><i>TypeAsc</i> - type</li><li><i>TypeDesc</i> - -type</li></ul>
         * @enum {string}
         */
        TransactionsSorting: TransactionsSorting;
        UpdateContact: {
            firstName: string;
            lastName: string;
            email: string;
            phoneNumber?: string | null;
        };
        /**
         * @description <ul><li><i>WalletManager</i> - wallet-manager</li><li><i>WalletOwner</i> - wallet-owner</li><li><i>WalletViewer</i> - wallet-viewer</li></ul>
         * @enum {string}
         */
        UserRole: UserRole;
        WalletsCurrency: {
            code: components['schemas']['CurrencyIsoCode'];
            name: string;
        };
        WalletsCurrencyRecord: {
            code: components['schemas']['CurrencyIsoCode'];
            name: string;
            isPayable: boolean;
            isFundable: boolean;
            isConvertible: boolean;
        };
        WalletsTransactionAnswer: {
            /** Format: uuid */
            id: string;
            type: components['schemas']['TransactionType'];
            currency: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            amount: number;
            kind: components['schemas']['TransactionKind'];
            status: components['schemas']['TransactionStatus'];
            reference?: string | null;
            description?: string | null;
            /** Format: uuid */
            relatedEntityId: string;
            /** Format: date-time */
            completedAt?: string | null;
            /** Format: date-time */
            createdAt: string;
            hasConversion?: boolean | null;
            hasRefund?: boolean | null;
        };
        WalletsWallet: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            organizationId: string;
            currency: components['schemas']['WalletsCurrency'];
            isPayable: boolean;
            isFundable: boolean;
            isConvertible: boolean;
            isVisible: boolean;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export enum ConversionsConversionStatus {
    cancelled = 'cancelled',
    completed = 'completed',
    created = 'created',
    failed = 'failed',
    pending = 'pending',
}
export enum CountryIsoCode {
    AD = 'AD',
    AE = 'AE',
    AF = 'AF',
    AG = 'AG',
    AI = 'AI',
    AL = 'AL',
    AM = 'AM',
    AO = 'AO',
    AQ = 'AQ',
    AR = 'AR',
    AS = 'AS',
    AT = 'AT',
    AU = 'AU',
    AW = 'AW',
    AX = 'AX',
    AZ = 'AZ',
    BA = 'BA',
    BB = 'BB',
    BD = 'BD',
    BE = 'BE',
    BF = 'BF',
    BG = 'BG',
    BH = 'BH',
    BI = 'BI',
    BJ = 'BJ',
    BL = 'BL',
    BM = 'BM',
    BN = 'BN',
    BO = 'BO',
    BQ = 'BQ',
    BR = 'BR',
    BS = 'BS',
    BT = 'BT',
    BV = 'BV',
    BW = 'BW',
    BY = 'BY',
    BZ = 'BZ',
    CA = 'CA',
    CC = 'CC',
    CD = 'CD',
    CF = 'CF',
    CG = 'CG',
    CH = 'CH',
    CI = 'CI',
    CK = 'CK',
    CL = 'CL',
    CM = 'CM',
    CN = 'CN',
    CO = 'CO',
    CR = 'CR',
    CU = 'CU',
    CV = 'CV',
    CW = 'CW',
    CX = 'CX',
    CY = 'CY',
    CZ = 'CZ',
    DE = 'DE',
    DJ = 'DJ',
    DK = 'DK',
    DM = 'DM',
    DO = 'DO',
    DZ = 'DZ',
    EC = 'EC',
    EE = 'EE',
    EG = 'EG',
    EH = 'EH',
    ER = 'ER',
    ES = 'ES',
    ET = 'ET',
    FI = 'FI',
    FJ = 'FJ',
    FK = 'FK',
    FM = 'FM',
    FO = 'FO',
    FR = 'FR',
    GA = 'GA',
    GB = 'GB',
    GD = 'GD',
    GE = 'GE',
    GF = 'GF',
    GG = 'GG',
    GH = 'GH',
    GI = 'GI',
    GL = 'GL',
    GM = 'GM',
    GN = 'GN',
    GP = 'GP',
    GQ = 'GQ',
    GR = 'GR',
    GS = 'GS',
    GT = 'GT',
    GU = 'GU',
    GW = 'GW',
    GY = 'GY',
    HK = 'HK',
    HM = 'HM',
    HN = 'HN',
    HR = 'HR',
    HT = 'HT',
    HU = 'HU',
    ID = 'ID',
    IE = 'IE',
    IL = 'IL',
    IM = 'IM',
    IN = 'IN',
    IO = 'IO',
    IQ = 'IQ',
    IR = 'IR',
    IS = 'IS',
    IT = 'IT',
    JE = 'JE',
    JM = 'JM',
    JO = 'JO',
    JP = 'JP',
    KE = 'KE',
    KG = 'KG',
    KH = 'KH',
    KI = 'KI',
    KM = 'KM',
    KN = 'KN',
    KP = 'KP',
    KR = 'KR',
    KW = 'KW',
    KY = 'KY',
    KZ = 'KZ',
    LA = 'LA',
    LB = 'LB',
    LC = 'LC',
    LI = 'LI',
    LK = 'LK',
    LR = 'LR',
    LS = 'LS',
    LT = 'LT',
    LU = 'LU',
    LV = 'LV',
    LY = 'LY',
    MA = 'MA',
    MC = 'MC',
    MD = 'MD',
    ME = 'ME',
    MF = 'MF',
    MG = 'MG',
    MH = 'MH',
    MK = 'MK',
    ML = 'ML',
    MM = 'MM',
    MN = 'MN',
    MO = 'MO',
    MP = 'MP',
    MQ = 'MQ',
    MR = 'MR',
    MS = 'MS',
    MT = 'MT',
    MU = 'MU',
    MV = 'MV',
    MW = 'MW',
    MX = 'MX',
    MY = 'MY',
    MZ = 'MZ',
    NA = 'NA',
    NC = 'NC',
    NE = 'NE',
    NF = 'NF',
    NG = 'NG',
    NI = 'NI',
    NL = 'NL',
    NO = 'NO',
    NP = 'NP',
    NR = 'NR',
    NU = 'NU',
    NZ = 'NZ',
    OM = 'OM',
    PA = 'PA',
    PE = 'PE',
    PF = 'PF',
    PG = 'PG',
    PH = 'PH',
    PK = 'PK',
    PL = 'PL',
    PM = 'PM',
    PN = 'PN',
    PR = 'PR',
    PS = 'PS',
    PT = 'PT',
    PW = 'PW',
    PY = 'PY',
    QA = 'QA',
    RE = 'RE',
    RO = 'RO',
    RS = 'RS',
    RU = 'RU',
    RW = 'RW',
    SA = 'SA',
    SB = 'SB',
    SC = 'SC',
    SD = 'SD',
    SE = 'SE',
    SG = 'SG',
    SH = 'SH',
    SI = 'SI',
    SJ = 'SJ',
    SK = 'SK',
    SL = 'SL',
    SM = 'SM',
    SN = 'SN',
    SO = 'SO',
    SR = 'SR',
    SS = 'SS',
    ST = 'ST',
    SV = 'SV',
    SX = 'SX',
    SY = 'SY',
    SZ = 'SZ',
    TC = 'TC',
    TD = 'TD',
    TF = 'TF',
    TG = 'TG',
    TH = 'TH',
    TJ = 'TJ',
    TK = 'TK',
    TL = 'TL',
    TM = 'TM',
    TN = 'TN',
    TO = 'TO',
    TR = 'TR',
    TT = 'TT',
    TV = 'TV',
    TW = 'TW',
    TZ = 'TZ',
    UA = 'UA',
    UG = 'UG',
    UM = 'UM',
    US = 'US',
    UY = 'UY',
    UZ = 'UZ',
    VA = 'VA',
    VC = 'VC',
    VE = 'VE',
    VG = 'VG',
    VI = 'VI',
    VN = 'VN',
    VU = 'VU',
    WF = 'WF',
    WS = 'WS',
    XK = 'XK',
    YE = 'YE',
    YT = 'YT',
    ZA = 'ZA',
    ZM = 'ZM',
    ZW = 'ZW',
}
export enum CurrencyIsoCode {
    ADA = 'ADA',
    AED = 'AED',
    AFN = 'AFN',
    ALL = 'ALL',
    AMD = 'AMD',
    ANG = 'ANG',
    AOA = 'AOA',
    ARS = 'ARS',
    AUD = 'AUD',
    AWG = 'AWG',
    AZN = 'AZN',
    BAM = 'BAM',
    BBD = 'BBD',
    BCH = 'BCH',
    BDT = 'BDT',
    BGN = 'BGN',
    BHD = 'BHD',
    BIF = 'BIF',
    BMD = 'BMD',
    BNB = 'BNB',
    BND = 'BND',
    BOB = 'BOB',
    BRL = 'BRL',
    BSD = 'BSD',
    BTC = 'BTC',
    BTN = 'BTN',
    BWP = 'BWP',
    BYN = 'BYN',
    BYR = 'BYR',
    BZD = 'BZD',
    CAD = 'CAD',
    CDF = 'CDF',
    CHE = 'CHE',
    CHF = 'CHF',
    CHW = 'CHW',
    CLF = 'CLF',
    CLP = 'CLP',
    CNY = 'CNY',
    COP = 'COP',
    COU = 'COU',
    CRC = 'CRC',
    CUC = 'CUC',
    CUP = 'CUP',
    CVE = 'CVE',
    CZK = 'CZK',
    DJF = 'DJF',
    DKK = 'DKK',
    DOGE = 'DOGE',
    DOP = 'DOP',
    DZD = 'DZD',
    EEK = 'EEK',
    EGP = 'EGP',
    ERN = 'ERN',
    ETB = 'ETB',
    ETC = 'ETC',
    ETH = 'ETH',
    EUR = 'EUR',
    FJD = 'FJD',
    FKP = 'FKP',
    GBP = 'GBP',
    GEL = 'GEL',
    GHS = 'GHS',
    GIP = 'GIP',
    GMD = 'GMD',
    GNF = 'GNF',
    GTQ = 'GTQ',
    GYD = 'GYD',
    HKD = 'HKD',
    HNL = 'HNL',
    HRK = 'HRK',
    HTG = 'HTG',
    HUF = 'HUF',
    IDR = 'IDR',
    ILS = 'ILS',
    INR = 'INR',
    IQD = 'IQD',
    IRR = 'IRR',
    ISK = 'ISK',
    JMD = 'JMD',
    JOD = 'JOD',
    JPY = 'JPY',
    KES = 'KES',
    KGS = 'KGS',
    KHR = 'KHR',
    KMF = 'KMF',
    KPW = 'KPW',
    KRW = 'KRW',
    KTD = 'KTD',
    KWD = 'KWD',
    KYD = 'KYD',
    KZT = 'KZT',
    LAK = 'LAK',
    LBP = 'LBP',
    LEO = 'LEO',
    LINK = 'LINK',
    LKR = 'LKR',
    LRD = 'LRD',
    LSL = 'LSL',
    LTC = 'LTC',
    LTL = 'LTL',
    LVL = 'LVL',
    LYD = 'LYD',
    MAD = 'MAD',
    MDL = 'MDL',
    MGA = 'MGA',
    MKD = 'MKD',
    MMK = 'MMK',
    MNT = 'MNT',
    MOP = 'MOP',
    MRO = 'MRO',
    MRU = 'MRU',
    MUR = 'MUR',
    MVR = 'MVR',
    MWK = 'MWK',
    MXN = 'MXN',
    MXV = 'MXV',
    MYR = 'MYR',
    MZN = 'MZN',
    NAD = 'NAD',
    NGN = 'NGN',
    NIO = 'NIO',
    NOK = 'NOK',
    NPR = 'NPR',
    NZD = 'NZD',
    OMR = 'OMR',
    PAB = 'PAB',
    PEN = 'PEN',
    PGK = 'PGK',
    PHP = 'PHP',
    PKR = 'PKR',
    PLN = 'PLN',
    PYG = 'PYG',
    QAR = 'QAR',
    RON = 'RON',
    RSD = 'RSD',
    RUB = 'RUB',
    RWF = 'RWF',
    SAR = 'SAR',
    SBD = 'SBD',
    SCR = 'SCR',
    SDG = 'SDG',
    SEK = 'SEK',
    SGD = 'SGD',
    SHP = 'SHP',
    SKK = 'SKK',
    SLE = 'SLE',
    SLL = 'SLL',
    SOS = 'SOS',
    SRD = 'SRD',
    SSP = 'SSP',
    STD = 'STD',
    STN = 'STN',
    SVC = 'SVC',
    SYP = 'SYP',
    SZL = 'SZL',
    THB = 'THB',
    TJS = 'TJS',
    TMT = 'TMT',
    TND = 'TND',
    TOP = 'TOP',
    TRX = 'TRX',
    TRY = 'TRY',
    TTD = 'TTD',
    TWD = 'TWD',
    TZS = 'TZS',
    UAH = 'UAH',
    UGX = 'UGX',
    USD = 'USD',
    USDT = 'USDT',
    UYU = 'UYU',
    UZS = 'UZS',
    VEF = 'VEF',
    VES = 'VES',
    VND = 'VND',
    VUV = 'VUV',
    WST = 'WST',
    XAF = 'XAF',
    XCD = 'XCD',
    XLM = 'XLM',
    XMR = 'XMR',
    XOF = 'XOF',
    XPF = 'XPF',
    XRP = 'XRP',
    YER = 'YER',
    ZAR = 'ZAR',
    ZMK = 'ZMK',
    ZMW = 'ZMW',
    ZWD = 'ZWD',
    ZWL = 'ZWL',
}
export enum FixedSide {
    buy = 'buy',
    sell = 'sell',
}
export enum FundingsFundingStatus {
    completed = 'completed',
    deleted = 'deleted',
    pending = 'pending',
}
export enum LegalEntityType {
    company = 'company',
    individual = 'individual',
}
export enum PayNetworkType {
    certis = 'certis',
    chaps = 'chaps',
    chats = 'chats',
    chips = 'chips',
    dcl = 'dcl',
    direct_entry = 'direct-entry',
    eft = 'eft',
    elixir = 'elixir',
    fast = 'fast',
    fed_ach = 'fed-ach',
    fedwire = 'fedwire',
    fps = 'fps',
    giro_zrt = 'giro-zrt',
    ibg = 'ibg',
    imps = 'imps',
    neft = 'neft',
    nics = 'nics',
    pesonet = 'pesonet',
    sepa = 'sepa',
    sic = 'sic',
    skn = 'skn',
    straksclearing = 'straksclearing',
    swift = 'swift',
    target2 = 'target2',
    trans_fond = 'trans-fond',
}
export enum PaymentChargeType {
    ours = 'ours',
    shared = 'shared',
}
export enum PaymentReviewStatus {
    in_review = 'in_review',
    passed = 'passed',
    rejected = 'rejected',
}
export enum PaymentType {
    priority = 'priority',
    regular = 'regular',
}
export enum PaymentsPaymentStatus {
    cancelled = 'cancelled',
    completed = 'completed',
    created = 'created',
    failed = 'failed',
    pending = 'pending',
    refunded = 'refunded',
}
export enum RefundsRefundStatus {
    completed = 'completed',
}
export enum ReportStatus {
    completed = 'completed',
    failed = 'failed',
    pending = 'pending',
}
export enum ReportType {
    account_statement = 'account-statement',
    balance_activity = 'balance-activity',
}
export enum RolePermission {
    assign_role_wallet_manager = 'assign-role-wallet-manager',
    assign_role_wallet_viewer = 'assign-role-wallet-viewer',
    delete_contact = 'delete-contact',
    make_conversion = 'make-conversion',
    make_payment = 'make-payment',
    set_wallet_visibility = 'set-wallet-visibility',
    view = 'view',
}
export enum TransactionKind {
    credit = 'credit',
    debit = 'debit',
}
export enum TransactionStatus {
    cancelled = 'cancelled',
    completed = 'completed',
    created = 'created',
    failed = 'failed',
    pending = 'pending',
}
export enum TransactionType {
    conversion = 'conversion',
    funding = 'funding',
    payment = 'payment',
    payment_fee = 'payment-fee',
    refund = 'refund',
}
export enum TransactionsSorting {
    accountAmount = 'accountAmount',
    ValueMinusaccountAmount = '-accountAmount',
    completedAt = 'completedAt',
    ValueMinuscompletedAt = '-completedAt',
    createdAt = 'createdAt',
    ValueMinuscreatedAt = '-createdAt',
    status = 'status',
    ValueMinusstatus = '-status',
    type = 'type',
    ValueMinustype = '-type',
}
export enum UserRole {
    wallet_manager = 'wallet-manager',
    wallet_owner = 'wallet-owner',
    wallet_viewer = 'wallet-viewer',
}
export type operations = Record<string, never>;
